<template>
  <div class="container">
    <el-card class="box-card" style="width: 100%;margin-top: 40px;">
      <template #header>
        <div class="card-header">
          <span>文章管理</span>
        </div>
      </template>
      <div class="cell">
        <span class="all-span">文章标题</span>
        <el-input v-model="detail.post_title" placeholder="请输入标题" class="all-style"/>
      </div>
      <div class="cell">
        <span class="all-span">发布日期</span>
        <el-config-provider :locale="locale">
          <el-date-picker
              class="all-style"
              v-model="detail.post_date"
              type="datetime"
              placeholder="请选择发布日期"
              value-format="YYYY-MM-DD HH:mm:ss"
          />
        </el-config-provider>
      </div>
      <div class="cell">
        <span class="all-span">类别</span>
        <el-cascader
            v-model="detail.options"
            :options="options"
            :props="props"
            placeholder="请选择类别"
            @change="_selectChange"
            style="width: 300px;"
        />
      </div>
      <div class="cell">
        <span class="all-span">浏览次数</span>
        <el-input v-model="detail.views_count" placeholder="请输入浏览次数" class="all-style"/>
      </div>
      <div class="cell">
        <span class="all-span">文章内容</span>
        <div class="cell-col">
          <div style="border: 1px solid #ccc">
            <Toolbar
                style="border-bottom: 1px solid #ccc"
                :editor="editorRef"
                :defaultConfig="toolbarConfig"
                :mode="mode"
            />
            <Editor
                style="height: 500px; overflow-y: hidden;"
                v-model="valueHtml"
                :defaultConfig="editorConfig"
                :mode="mode"
                @onCreated="handleCreated"
            />
          </div>
        </div>
      </div>
      <div class="cell" style="justify-content: center;margin-bottom: 30px;">
        <el-button @click="_edit" round size="large" type="primary" style="width: 220px;">提交</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import http from "@/util/http";
import {ElMessage, ElMessageBox} from "element-plus";

import zhCn from "element-plus/lib/locale/lang/zh-cn";
import '@wangeditor/editor/dist/css/style.css' // 引入 css

import {onBeforeUnmount, ref, shallowRef, onMounted} from 'vue'
import {Editor, Toolbar} from '@wangeditor/editor-for-vue'

let editorAll
export default {
  name: "DetailPageAdmin",
  components: {Editor, Toolbar},
  setup() {
    // 编辑器实例，必须用 shallowRef
    const editorRef = shallowRef()

    // 内容 HTML
    const valueHtml = ref('')

    // 模拟 ajax 异步获取内容
    onMounted(() => {
    })

    const toolbarConfig = {
      excludeKeys: [
        "group-video", "insertLink"
      ]
    }
    const editorConfig = {placeholder: '请输入文章内容', MENU_CONF: {}}

    editorConfig.MENU_CONF['uploadImage'] = {
      server: 'http://www.chinese-engineers.com/api/v1/imageUpload',
      fieldName: 'file',
      allowedFileTypes: ['image/*'],
      withCredentials: false,
      timeout: 50 * 1000,
      // 上传之前触发
      onBeforeUpload(file) {
        // file 选中的文件，格式如 { key: file }
        return file
        // 可以 return
        // 1. return file 或者 new 一个 file ，接下来将上传
        // 2. return false ，不上传这个 file
      },
      // 上传进度的回调函数
      onProgress(progress) {
        // progress 是 0-100 的数字
        console.log('progress', progress)
      },
      // 单个文件上传成功之后
      onSuccess(file, res) {
        console.log(`${file.name} 上传成功`, res)
      },
      // 单个文件上传失败
      onFailed(file, res) {
        console.log(`${file.name} 上传失败`, res)
      },
      // 上传错误，或者触发 timeout 超时
      onError(file, err, res) {
        console.log(`${file.name} 上传出错`, err, res)
      },
    }

    // 组件销毁时，也及时销毁编辑器
    onBeforeUnmount(() => {
      const editor = editorRef.value
      if (editor == null) return
      editor.destroy()
    })

    const handleCreated = (editor) => {
      editorRef.value = editor // 记录 editor 实例，重要！
      editorAll = editor
    }

    return {
      editorRef,
      valueHtml,
      mode: 'default', // 或 'simple'
      toolbarConfig,
      editorConfig,
      handleCreated
    };
  },
  data() {
    return {
      locale: zhCn,
      detail: {
        ID: undefined,
        post_title: undefined,
        post_date: undefined,
        post_parent: undefined,
        post_child: undefined,
        views_count: undefined,
        post_content: undefined,
        isShowHomePage: undefined,
        isShowHomeBottom: undefined,
        showOrder: undefined,
        isDelete: undefined,
        id: undefined,
        options: undefined
      },
      props: {
        expandTrigger: 'hover',
      },
      options: [
        {
          value: 1,
          label: '会员中心',
          children: []
        },
        {
          value: 2,
          label: '协会概况',
          children: [],
        },
        {
          value: 3,
          label: '新闻资讯',
          children: [],
        },
        {
          value: 4,
          label: '行业动态',
          children: []
        },
        {
          value: 5,
          label: '信息中心',
          children: []
        }
      ]
    }
  },
  mounted() {
    this._getDetail()
  },
  methods: {
    _getDetail() {
      if (!this.$route.query.p) {
        return
      }

      http.get('articleDetail', {
        id: this.$route.query.p
      })
          .then((res) => {
            if (res.data.status === 0) {
              const data = res.data.data
              data.options = []
              data.options.push(data.post_parent)
              this.detail = data
              editorAll.dangerouslyInsertHtml('<div>' + this.detail.post_content + '</div>')
              console.log(this.detail.post_content)
            } else {
              ElMessage.error(res.data.content)
              if (res.data.status === 201) {
                this.$router.push({
                  path: '/AdminLogin'
                })
              }
            }
          })
    },
    _edit() {
      if (!this.detail.post_title) {
        ElMessage.warning("标题必须填写")
        return
      }
      if (!this.detail.post_date) {
        ElMessage.warning("日期必须选择")
        return
      }
      if (!this.detail.views_count) {
        ElMessage.warning("浏览次数必须填写")
        return
      }

      this.detail.post_content = editorAll.getHtml()

      http.post('editArticle', this.detail)
          .then((res) => {
            if (res.data.status === 0) {

              ElMessage.success(res.data.content)
              ElMessageBox.confirm(
                  '编辑成功，是否跳转到对应页面查看效果？',
                  '提示',
                  {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                  }
              )
                  .then(() => {
                    const detailId = this.detail.ID ? this.detail.ID : res.data.data
                    let routeData = this.$router.resolve({
                      path: "/detail",
                      query: {
                        id: detailId
                      }
                    })

                    window.open(routeData.href, '_blank')
                  })
                  .catch(() => {

                  })
            } else {
              ElMessage.error(res.data.content)
            }
          })
    },
    _selectChange(e) {
      if (e.length >= 2) {
        this.detail.post_parent = e[0]
        this.detail.post_child = e[1]
      } else {
        this.detail.post_parent = e[0]
        this.detail.post_child = undefined
      }
      this.detail.options = e
    }
  }
}
</script>

<style scoped>
.cell {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 20px;
}

.cell-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1;
}

.all-span {
  margin-right: 30px;
  width: 100px;
  text-align: end;
}

.all-style {
  display: flex;
  flex: 1;
}
</style>